// src/components/dataone/SafetySection.tsx
'use client';

import React from 'react';

interface SafetySectionProps {
  safetyEquipment: Record<string, string>;
}

const SafetySection: React.FC<SafetySectionProps> = ({ safetyEquipment }) => {
  const entries = Object.entries(safetyEquipment || {});

  if (entries.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">Safety Equipment</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {entries.map(([key, value]) => (
          <div key={key} className="border p-3 rounded">
            <p className="font-medium text-gray-800">{key}</p>
            <p className="text-sm text-gray-600">{value || '✓'}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SafetySection;
